function HeaderGap() {
    return null;
}

HeaderGap.displayName = 'HeaderGap';
export default HeaderGap;
